import { useState, useEffect } from "react";

export function usePreferences(token) {
  const [soundEnabled, setSoundEnabled] = useState(true);
  const [timerSoundEnabled, setTimerSoundEnabled] = useState(true);

  const API_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const fetchPreferences = async () => {
      try {
        const res = await fetch(`${API_URL}/api/auth/preferences`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (res.ok) {
          const prefs = await res.json();
          console.log("📥 Préférences récupérées :", prefs); // <-- DEBUG
          setSoundEnabled(prefs.soundEnabled);
          setTimerSoundEnabled(prefs.timerSoundEnabled);
        }
      } catch (err) {
        console.error("Erreur chargement préférences:", err);
      }
    };
    if (token) fetchPreferences();
  }, [token]);

  return { soundEnabled, timerSoundEnabled };
}
